var Mode;
(function (Mode) {
    Mode["chrome"] = "chrome";
    Mode["safari"] = "safari";
    Mode["ie"] = "ie";
    Mode["firefox"] = "firefox";
    Mode["other"] = "other";
})(Mode || (Mode = {}));
var implementation = {
    _mode: null,
    /**
     * @param {Error} ex The error to create a stacktrace from (optional)
     */
    run: function (ex) {
        if (!this._mode) {
            this._mode = this.mode(ex);
        }
        var mode = this._mode;
        if (mode === Mode.other) {
            // return this.other(arguments.callee);
            return [];
        }
        return this[mode](ex);
    },
    /**
     * Mode could differ for different exception, e.g.
     * exceptions in Chrome may or may not have arguments or stack.
     *
     * @return {String} mode of operation for the exception
     */
    mode: function (error) {
        if (error.arguments && error.stack) {
            return Mode.chrome;
        }
        else if (error.stack && error.sourceURL) {
            return Mode.safari;
        }
        else if (error.stack && error.number) {
            return Mode.ie;
        }
        else if (error.stack && error.fileName) {
            return Mode.firefox;
        }
        else if (error.stack && !error.fileName) {
            // Chrome 27 does not have e.arguments as earlier versions,
            // but still does not have e.fileName as Firefox
            return Mode.chrome;
        }
        return Mode.other;
    },
    /**
     * Given an Error object, return a formatted Array based on Chrome's stack string.
     *
     * @param error - Error object to inspect
     * @return Array<String> of function calls, files and line numbers
     */
    chrome: function (error) {
        return error.stack
            ? (error.stack + "\n")
                .replace(/^[\s\S]+?\s+at\s+/, ' at ') // remove message
                .replace(/^\s+(at eval )?at\s+/gm, '') // remove 'at' and indentation
                // .replace(/^([^\(]+?)([\n$])/gm, '{anonymous}() ($1)$2')
                .replace(/^Object.<anonymous>\s*\(([^)]+)\)/gm, '{anonymous}() ($1)')
                .replace(/^(.+) \((.+)\)$/gm, '$1@$2')
                .split('\n')
                .slice(0, -1)
            : [];
    },
    /**
     * Given an Error object, return a formatted Array based on Safari's stack string.
     *
     * @param error - Error object to inspect
     * @return Array<String> of function calls, files and line numbers
     */
    safari: function (error) {
        return error.stack
            ? error.stack
                .replace(/\n\[native code\]/m, '')
                .replace(/^(?=\w+Error:).*$\n/m, '')
                .replace(/^@/gm, '{anonymous}()@')
                .split('\n')
            : [];
    },
    /**
     * Given an Error object, return a formatted Array based on IE's stack string.
     *
     * @param error - Error object to inspect
     * @return Array<String> of function calls, files and line numbers
     */
    ie: function (error) {
        return error.stack
            ? error.stack
                .replace(/^\s*at\s+(.*)$/gm, '$1')
                .replace(/^Anonymous function\s+/gm, '{anonymous}() ')
                .replace(/^(.+)\s+\((.+)\)$/gm, '$1@$2')
                .split('\n')
                .slice(1)
            : [];
    },
    /**
     * Given an Error object, return a formatted Array based on Firefox's stack string.
     *
     * @param error - Error object to inspect
     * @return Array<String> of function calls, files and line numbers
     */
    firefox: function (error) {
        return error.stack
            ? error.stack
                .replace(/(?:\n@:0)?\s+$/m, '')
                .replace(/^(?:\((\S*)\))?@/gm, '{anonymous}($1)@')
                .split('\n')
            : [];
    },
};
/**
 * Main function giving a function stack trace with a forced or passed in Error
 *
 * @cfg {Error} e The error to create a stacktrace from
 * @return {Array} of Strings with functions, lines, files, and arguments where possible
 */
function formatStackTrace(error) {
    if (!(error instanceof Error)) {
        if (typeof error.stack === 'string') {
            return [error.stack];
        }
        return error.stack || [];
    }
    var res = implementation.run(error);
    if ('__newError__' in error) {
        res = res.slice(1);
    }
    return res;
}

/**
 *
 * @param name
 * @param msg
 * @return {*}
 * @constructor
 */
var ErrorMessage = function (name, msg, isDebug) {
    var error = new Error(msg);
    if (isDebug) {
        error.name = name;
        error.__newError__ = true;
        return error;
    }
    try {
        throw error;
    }
    catch (er) {
        er.name = name;
        er.__newError__ = true;
        return er;
    }
};

var ERROR_REPORT_PROPERTIES = [
    'name',
    'message',
    'number',
    'filename',
    'lineno',
    'colno',
    'user_id',
    'device_id',
    'app_version',
    'app_build',
    'app_label',
    'deploy_info',
    'app_state',
    'state_history',
    'current_url',
    'target_url',
    'ua',
    'ua_full',
    'lang',
    'images_root',
    'message',
    'udid',
    'debug_info',
    'stack',
    'origin',
    'level',
];
var ErrorLevel;
(function (ErrorLevel) {
    ErrorLevel["DEBUG"] = "debug";
    ErrorLevel["ERROR"] = "error";
    ErrorLevel["FATAL"] = "fatal";
    ErrorLevel["INFO"] = "info";
    ErrorLevel["UNKNOWN"] = "unknown";
    ErrorLevel["WARN"] = "warning";
})(ErrorLevel || (ErrorLevel = {}));

function createErrorLogger(_a) {
    var getErrorLogUrl = _a.getErrorLogUrl, addGlobals = _a.addGlobals, _b = _a.beforeLogging, beforeLogging = _b === void 0 ? function () { return true; } : _b, 
    // eslint-disable-next-line no-empty-function
    _c = _a.applyRequestMiddleware, 
    // eslint-disable-next-line no-empty-function
    applyRequestMiddleware = _c === void 0 ? function () { } : _c, isDebug = _a.isDebug;
    if (!isFunction(addGlobals)) {
        throw new Error('addGlobals prop is mandatory for error logging.');
    }
    if (!isFunction(getErrorLogUrl)) {
        throw new Error('getErrorLogUrl prop is mandatory for error logging.');
    }
    if (!isFunction(beforeLogging)) {
        throw new Error('beforeLogging must be a function.');
    }
    if (!isFunction(applyRequestMiddleware)) {
        throw new Error('applyRequestMiddleware must be a function.');
    }
    return function _logError(error, errorDetails) {
        return logError({
            error: error,
            errorDetails: errorDetails,
            getErrorLogUrl: getErrorLogUrl,
            addGlobals: addGlobals,
            beforeLogging: beforeLogging,
            isDebug: Boolean(isDebug),
            skipAddGlobals: false,
            applyRequestMiddleware: applyRequestMiddleware,
        });
    };
}
function logError(_a) {
    var error = _a.error, errorDetails = _a.errorDetails, getErrorLogUrl = _a.getErrorLogUrl, addGlobals = _a.addGlobals, beforeLogging = _a.beforeLogging, isDebug = _a.isDebug, skipAddGlobals = _a.skipAddGlobals, applyRequestMiddleware = _a.applyRequestMiddleware;
    try {
        var errorReport = normalizeError(error, isDebug);
        if (errorDetails) {
            for (var errorDetail in errorDetails) {
                if (!hasKey(errorDetails, errorDetail)) {
                    continue;
                }
                if (errorDetails[errorDetail] instanceof Error) {
                    logError({
                        error: errorDetails[errorDetail],
                        errorDetails: null,
                        getErrorLogUrl: getErrorLogUrl,
                        addGlobals: addGlobals,
                        beforeLogging: beforeLogging,
                        isDebug: isDebug,
                        skipAddGlobals: skipAddGlobals,
                        applyRequestMiddleware: applyRequestMiddleware,
                    });
                }
                else if (ERROR_REPORT_PROPERTIES.indexOf(errorDetail) !== -1) {
                    errorReport[errorDetail] = errorDetails[errorDetail];
                }
                else if (isDebug) {
                    // eslint-disable-next-line no-console
                    console.warn("Sending unsupported property in error-logger: " + errorDetail);
                }
            }
        }
        if (!skipAddGlobals) {
            try {
                addGlobals(errorReport);
            }
            catch (addGlobalsErr) {
                // Log the error and continue
                logError({
                    error: error,
                    errorDetails: errorDetails,
                    addGlobals: addGlobals,
                    beforeLogging: beforeLogging,
                    getErrorLogUrl: getErrorLogUrl,
                    isDebug: isDebug,
                    skipAddGlobals: true,
                    applyRequestMiddleware: applyRequestMiddleware,
                });
            }
        }
        if (beforeLogging(errorReport)) {
            sendLog(getErrorLogUrl(), errorReport, applyRequestMiddleware);
        }
    }
    catch (logErrorError) {
        if (isDebug) {
            // eslint-disable-next-line no-console
            console.error(logErrorError);
        }
    }
}
function sendLog(errorLogUrl, errorReport, applyRequestMiddleware) {
    // eslint-disable-next-line no-undef
    var request = new XMLHttpRequest();
    request.open('POST', errorLogUrl, true);
    request.withCredentials = true;
    applyRequestMiddleware(request);
    request.send(JSON.stringify(errorReport));
}
function normalizeError(error, isDebug) {
    var errorMessage;
    var stack;
    if (!(error instanceof Error)) {
        if (!error) {
            errorMessage = new ErrorMessage('NonError', 'null', isDebug);
        }
        else if (typeof error === 'object') {
            var message = 'message' in error ? error.message : getSafeJsonString(error);
            if ('stack' in error) {
                stack = error.stack;
            }
            errorMessage = new ErrorMessage(error.name || 'NonError', message, isDebug);
        }
        else {
            errorMessage = new ErrorMessage('NonError', "NonEmpty " + error, isDebug);
        }
    }
    else {
        errorMessage = error;
        stack = formatStackTrace(error);
    }
    return {
        name: errorMessage.name,
        message: errorMessage.message,
        number: errorMessage.number,
        filename: errorMessage.fileName,
        lineno: errorMessage.lineno,
        colno: errorMessage.colno,
        stack: stack,
    };
}
/**
 * Takes an array of ANY values and returns some form of valid JSON string
 * @param {Array} obj
 * @returns String
 */
function getSafeJsonString(serialisable) {
    if (serialisable instanceof Array) {
        return JSON.stringify(serialisable.map(function (item) { return getSafeJson(item); }));
    }
    return JSON.stringify(getSafeJson(serialisable));
}
function getSafeJson(item) {
    try {
        if (item && isFunction(item.toJSON)) {
            return item.toJSON();
        }
        return JSON.stringify(item);
    }
    catch (err) {
        return { error: "Unable to get safe json: " + err.message };
    }
}
function isFunction(item) {
    return item instanceof Function;
}
function hasKey(obj, key) {
    return key in obj;
}

export { ERROR_REPORT_PROPERTIES, ErrorLevel, ErrorMessage, createErrorLogger, formatStackTrace };
